import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  handleChange(e) {
    const saveChanges = e.currentTarget.closest('form').querySelector(".save-changes")

    if (this.atLeastOneBookableChecked) {
      this.amenityCheckboxes.forEach(el => el.disabled = false)

      if (this.atLeastOneAmenityChecked) {
        saveChanges.style.display = "flex"
      }
    } else {
      this.amenityCheckboxes.forEach(el => el.disabled = true)
      saveChanges.style.display = "none"
    }
  }

  handleSelectAll(e) {
    const checked = e.currentTarget.checked
    if (checked) {
      this.bookableCheckboxes.forEach(el => el.checked = true)
    } else {
      this.bookableCheckboxes.forEach(el => el.checked = false)
    }
    this.handleChange(e)
  }


  /**
    * Private Methods
    */

  get atLeastOneBookableChecked() {
    return this.checkedBookableCheckboxes.length > 0
  }

  get atLeastOneAmenityChecked() {
    return document.querySelector(".bulk-edit-container").querySelectorAll("input[type='checkbox']:checked").length > 0
  }

  get amenityCheckboxes() {
    return document.querySelector(".bulk-edit-container").querySelectorAll("input[type='checkbox']")
  }

  get checkedBookableCheckboxes() {
    return this.element.querySelectorAll(("input[type='checkbox']:checked"))
  }

  get bookableCheckboxes() {
    return this.element.querySelectorAll(("input[type='checkbox']"))
  }
}


